import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNotification } from '@reducers/notification';
import CounterCash from '@components/CounterCash';
import cn from 'classnames';
import Modal from '@components/common/Modal';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Loader from '@components/common/Loader/newLoaderModal';
import {
  employeeCashOut,
  drawerCashOut,
  updateEmployeeCashOut,
  updateDrawerCashOut,
  getCashIn,
  updateCashIn
} from '@reducers/cashOut';
import EventEmitter from '@utility/eventSubscribers';
import { APP_CONFIG } from '@constants';

const Countercash = (props) => {

  // Props Destructuring

  const {deviceInfo, userInfo, getCashIn, updateEmployeeCashOut, setNotification, updateCashIn} = props;

  // State Management

  const [confirmCashOut, setConfirmCashOut] = useState(false);
  const [amount, setAmount] = useState(0);
  const [cashInData, setCashInData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [drawerAlert, setDrawerAlert] = useState({ isOpen: false, message: '' });
  const isCashIn = props.location.pathname.includes('cashIn');
  const isDrawerOpen = props.location.pathname.includes('bills') && props.location.state && props.location.state.drawerOpen;
  const { drawerIpAddress, drawerPort } = deviceInfo;
  const eventObj = { drawerIpAddress, drawerPort };

  // React Hooks

  useEffect(() => {
    if (isCashIn) {
      const dataTosend = {
        storeId: userInfo.storeId,
        employeeId: userInfo.id,
        deviceId: deviceInfo.deviceId,
      };
      getCashIn(dataTosend).then((res) => {
        setCashInData(res);
        if (userInfo.supportsCashDrawer) {
          setLoader(true);
          if (window.ReactNativeWebView) {
            EventEmitter.drawerOpen(eventObj);
            handleDrawerStatusCheck();
          }
        }
      });
    }
  }, []);

  // Methods

  const handleConfirmCashOut = () => {
    setConfirmCashOut(false);
    const dataToSend = {
      storeId: userInfo.storeId,
      employeeId: userInfo.id,
      deviceId: deviceInfo.deviceId,
      amount
    };
    if (userInfo.supportsCashDrawer && deviceInfo.storeDrawerId) {
      updateEmployeeCashOut({ ...dataToSend }).then((res) => {
        props.history.replace({ pathname: '/cashOut/confirmation', state: { response: res } });
      }).catch((err) => {
        setNotification({
          type: 'danger',
          message: err.message
        });
      });
    } else {
      updateEmployeeCashOut(dataToSend).then((res) => {
        props.history.replace({
          pathname: '/report/server/cashOut',
          state: { response: res }
        });
      }).catch((err) => {
        setNotification({
          type: 'danger',
          message: err.message
        });
      });
    }
  };

  const intervalId = useRef(null);
  const successDrawerOpen = () => {
    intervalId.current = setInterval(() => {
      EventEmitter.drawerStatus(eventObj, (res) => {
        if ([9, 1].includes(res.status)) {
          clearInterval(intervalId.current);
        }
      });
    }, 1000);
  };

  const timeoutId = useRef(null);
  let retryCount = 0;
  const handleDrawerStatusCheck = () => {
    retryCount += 1;
    EventEmitter.drawerStatus(eventObj, (res) => {
      timeoutId.current = setTimeout(() => {
        clearTimeout(timeoutId.current);
        if ([1].includes(res.status) && retryCount <= 3) {
          return handleDrawerStatusCheck();
        }
        if (res.status === 0) {
          setLoader(false);
          return successDrawerOpen();
        }
        setLoader(false);
        return setDrawerAlert({ isOpen: true, message: `${CUSTOM_MESSAGES().DRAWER_CASHIN_FAIL}` });
      }, 1000);
    });
  };

  const handleCashOutSubmit = (value) => {
    setAmount(Number(value?.amount));
    setConfirmCashOut(true);
  };

  const handleCashIn = (value) => {
    const dataToSend = {
      storeId: userInfo.storeId,
      employeeId: userInfo.id,
      deviceId: deviceInfo.deviceId,
      amount: Number(value?.amount)
    };
    updateCashIn(dataToSend).then(() => {
      props.navigate( `${APP_CONFIG.BASE_URL}/serverApp/checks`, { replace: true });
    }).catch((err) => {
      setNotification({
        message: err.message,
        type: 'danger'
      });
    });
  };

  // HTML CSS Code

  return (
    <>
      {(props.loading || loader) && <Loader />}
      <CounterCash {...props} onSubmit={isCashIn ? handleCashIn : handleCashOutSubmit} isCashIn={isCashIn} cashInData={cashInData} isDrawerOpen={isDrawerOpen} />
      {confirmCashOut && (
        <Modal
          isOpen={confirmCashOut}
          isModalCenter
        >
          <div className={cn('w-100 fs-18 row mx-0 p-2 text-primary od-text-primary')}>
            <div className="text-center py-2">{CUSTOM_MESSAGES().CONFIRM_CASHOUT}</div>
            <div role="presentation" onClick={() => setConfirmCashOut(false)} className="col-6 text-center px-2">
              <div className="od-btn-primary btn35 roundedSm">{LABEL().NO}</div>
            </div>
            <div role="presentation" onClick={() => handleConfirmCashOut()} className="col-6 text-center px-2">
              <div className="od-btn-primary btn35 roundedSm">{LABEL().YES}</div>
            </div>
          </div>
        </Modal>
      )}
      {drawerAlert?.isOpen && (
        <Modal
          isOpen={drawerAlert?.isOpen}
          isModalCenter
        >
          <div className={cn('w-100 fs-18 row mx-0 p-2 text-primary od-text-primary')}>
            <div className="text-center py-2 w-100">{drawerAlert?.message}</div>
            <div role="presentation" onClick={() => { setDrawerAlert({ isOpen: false, message: '' }); }} className="col-6 offset-3 p-2">
              <div className="od-btn-primary  text-center btn-primary btn-ripple btn35 roundedSm">{LABEL().CLOSE}</div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

// Redux Part

const mapStateToProps = ({
  oauth, cashOut, orders
}) => ({
  loading: cashOut.loading,
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  deviceInfo: oauth.deviceInformation,
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setNotification,
  employeeCashOut,
  drawerCashOut,
  updateEmployeeCashOut,
  updateDrawerCashOut,
  getCashIn,
  updateCashIn
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Countercash);
